import React from "react";
import Container from "@material-ui/core/Container";

const About = () => {
  return (
    <Container className="about">
      <h2>
        What's up, Dear Developers?{" "}
        <span role="img" aria-label="hey">
          🙋‍♂️
        </span>
      </h2>
      <p>
        My name is{" "}
        <a
          href="https://arturmaiz.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Artur Maizelev
        </a>
        , I'm Full Stack Developer.
      </p>
      <p>
        I'm went over a excellent tutorials of amazing web developers and some
        are less gainful or even terrible.
      </p>
      <p>
        I've selected the exceptional developers I consider is the best to learn
        from them all about web development.
      </p>
      <p>
        I'm positive there are a ton of superb web developers across the Web
        that I don't know that is the reason I'm simply discussing my
        experience.
      </p>
      <h2>
        <span role="img" aria-label="star">
          🤩
        </span>{" "}
        Well, then, I hope you're ready to welcome the Super Stars{" "}
        <span role="img" aria-label="star">
          🤩
        </span>
      </h2>
    </Container>
  );
};

export default About;
